export function filterSlugCategoriesByScreenSizes(slugs, isXs, isSm) {
  return slugs.filter(function (slug) {
    return slug.renderAllScreenSizes || isXs && slug.renderOnXs || isSm && slug.renderOnSm;
  }).map(function (slug) {
    return slug.slug;
  });
}